import styled from "styled-components";

export const Content = styled.div`
  position: relative;
  z-index: 3;
  max-width: 480px;
  margin: 48px auto;
  padding: 34px 40px;
  background: linear-gradient(180deg, rgba(10, 16, 32, 0.82), rgba(8, 12, 26, 0.88));
  border: 1px solid rgba(255, 200, 96, 0.55);
  border-radius: 20px;
  box-shadow: 0 0 46px rgba(255, 186, 66, 0.32), 0 0 0 1px rgba(255, 200, 96, 0.22),
    0 30px 80px -40px rgba(0, 0, 0, 0.9);
  backdrop-filter: blur(12px);
  text-align: left;
  color: #e9eefc;
`;

export const Brand = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  margin-bottom: 16px;
  font-family: "Exo 2", system-ui, sans-serif;
  font-weight: 800;
  font-size: 21px;
  letter-spacing: 0.2px;
  color: #ffffff;
`;

export const BrandMark = styled.span`
  width: 30px;
  height: 30px;
  border-radius: 8px;
  display: grid;
  place-items: center;
  background: linear-gradient(140deg, #60a5fa, #1d4ed8);
  box-shadow: 0 6px 18px -6px rgba(59, 130, 246, 0.8);

  svg {
    width: 17px;
    height: 17px;
    stroke: #fff;
    fill: none;
    stroke-width: 2;
  }
`;

export const BrandName = styled.span`
  b {
    color: #60a5fa;
    font-weight: 800;
  }
`;

export const Logo = styled.div`
  text-align: center;
`;

export const H1 = styled.h1`
  font-family: "Exo 2", system-ui, sans-serif;
  font-size: 23px;
  font-weight: 800;
  letter-spacing: -0.5px;
  margin: 6px auto 4px;
  text-align: center;
  color: #ffffff;
`;

export const P = styled.div`
  margin: 10px 0;
  text-align: justify;
  font-family: "Manrope", system-ui, sans-serif;
  font-size: 14.5px;
  line-height: 1.6;
  color: #a9bbdd;
`;

export const Form = styled.div``;

export const Label = styled.form`
  display: block;
  font-family: "Manrope", system-ui, sans-serif;
  font-size: 12.5px;
  letter-spacing: 0.3px;
  color: #8ea3ca;
  margin-bottom: 6px;
`;

export const InputTypeText = styled.input`
  width: 100%;
  box-sizing: border-box;
  background: rgba(4, 8, 20, 0.6);
  border: 1px solid rgba(120, 160, 255, 0.16);
  border-radius: 10px;
  padding: 12px 14px;
  color: #e9eefc;
  font-family: "Manrope", system-ui, sans-serif;
  font-size: 15px;
  outline: none;
  transition: border-color 0.2s, box-shadow 0.2s;

  &::placeholder {
    color: #5f7396;
  }
  &:focus {
    border-color: #60a5fa;
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.18);
  }
`;

export const InputTypeSubmit = styled.input`
  width: 100%;
  cursor: pointer;
  margin-top: 8px;
  border: none;
  border-radius: 12px;
  padding: 15px 0;
  color: #fff;
  font-family: "Exo 2", system-ui, sans-serif;
  font-weight: 700;
  font-size: 15px;
  background: linear-gradient(180deg, #3b82f6, #1d4ed8);
  box-shadow: 0 14px 34px -12px rgba(59, 130, 246, 0.75);
  transition: transform 0.2s, box-shadow 0.2s;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 18px 40px -12px rgba(59, 130, 246, 0.85);
  }
`;

export const Modal = styled.div`
  margin: 12px 0 0;
  padding: 12px 16px;
  border-radius: 10px;
  border: 1px solid rgba(55, 224, 166, 0.35);
  background: rgba(55, 224, 166, 0.1);
  color: #7ff0c2;
  font-family: "Manrope", system-ui, sans-serif;
  font-size: 14px;
  line-height: 1.55;
`;
